export const CERTIFICATION_CHANNEL_NAME = 'doctornow-certification';

export const CERTIFICATION_MESSAGE_TYPE = {
  SUCCESS: 'CERTIFICATION_SUCCESS',
  FAIL: 'CERTIFICATION_FAIL',
} as const;

export type CertificationMessageType = (typeof CERTIFICATION_MESSAGE_TYPE)[keyof typeof CERTIFICATION_MESSAGE_TYPE];

export interface CertificationMessage {
  type: CertificationMessageType;
  timestamp: number;
}
